import { render, staticRenderFns } from "./AdminSentimentVguard.vue?vue&type=template&id=091379ea&scoped=true"
import script from "./AdminSentimentVguard.vue?vue&type=script&lang=js"
export * from "./AdminSentimentVguard.vue?vue&type=script&lang=js"
import style0 from "./AdminSentimentVguard.vue?vue&type=style&index=0&id=091379ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091379ea",
  null
  
)

export default component.exports